<template>
  <div>
    <homeNav/>
    <homeCarousel/>
    <homeNews/>
    <homeOnlineEduVideo/>
    <homeProResource/>
    <homePartner/>
    <backtop/>
    <homeFooter/>
  <test/>
  </div>
</template>

<script>

import homeNav from '../../components/homeNav';
import homeCarousel from './components/homeCarousel';
import homeNews from './components/homeNews';
import homeOnlineEduVideo from './components/homeOnlineEduVideo';
import homeProResource from './components/homeProResource';
import homePartner from './components/homePartner';
import homeFooter from '../../components/homeFooter';
import backtop from '../../components/backtop';
import test from '../../components/test'
export default {
  name: 'home',
  components: {
    homeNav,
    homeCarousel,
    homeNews,
    homeOnlineEduVideo,
    homeProResource,
    homePartner,
    homeFooter,
    backtop,
    test
  }


}
</script>

<style>

</style>
